/** Use a fixed locale and timezone so prerendered and hydrated dates match. */
export function formatArticleDate(date: string) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(date));
}
